import React from "react";
import { createReducerFromMap } from "@coverme/redux";

const initialState = {
    entry: false,
    verification: false,
    contractConsent: true,
    coverage: false,
    coverageSummary: false,
    patientInfoScreening: false,
    householdMatrix: false,
    personInfoScreening: false,
    government: false,
    financialAssistance: false,
    longTermCare: false,
    exchange: false,
    documentation: false,
};

function isEmptyOrHasOnlyNulls(object, except = []) {
    if (Object.keys(object).length === 0 && object.constructor === Object) {
        return true;
    }

    for (const prop in object) {
        if (!object.hasOwnProperty(prop)) {
            continue;
        }

        if (except.indexOf(prop) > -1) {
            continue;
        }

        if (object[prop] != null) {
            return false;
        }
    }

    return true;
}

function areAllObjectsInArrayEmptyOrNull(sourceArray, except = []) {
    if (sourceArray == null) {
        return true;
    }

    if (sourceArray.length === 0) {
        return true;
    }

    for (const item of sourceArray) {
        if (!isEmptyOrHasOnlyNulls(item, except)) {
            return false;
        }
    }

    return true;
}

function markVisited(section, state) {
    return {
        ...state,
        [section]: true,
    };
}

function markHouseholdMatrixAsVisited(state) {
    return {
        ...state,
        householdMatrix: true,
        personInfoScreening: false,
        documentation: false,
    };
}

function markPersonInfoScreengAsVisited(state) {
    return {
        ...state,
        householdMatrix: true,
        personInfoScreening: true,
    };
}

function getInterview(state, { value }) {
    let result = { ...initialState };
    if (value.entry?.encounterId != null) {
        result.entry = true;
        result.verification = true;
    }

    if (value.coverage) {
        result.coverage = true;
    }

    if (value.patientInfoScreening) {
        if (!isEmptyOrHasOnlyNulls(value.patientInfoScreening)) {
            result.patientInfoScreening = true;
        }
    }

    if (value.householdMembers && value.householdMembers.length > 0) {
        result.patientInfoScreening = true;
        result.householdMatrix = true;
    }

    if (
        value.personInfoScreenings &&
        value.personInfoScreenings.length > 0 &&
        areAllObjectsInArrayEmptyOrNull(value.personInfoScreenings, ["personId", "income", "areParentsMarried"]) ===
        false
    ) {
        result.patientInfoScreening = true;
        result.householdMatrix = true;
        result.personInfoScreening = true;
        result.documentation = true;
    }

    if (value.exchange && isEmptyOrHasOnlyNulls(value.exchange, []) === false) {
        result.exchange = true;
    }
    var hasRelationToRP = value?.householdMembers?.filter(x => x.relationshipToResponsibleParty == null || x.relationshipToResponsibleParty == undefined || x.relationshipToResponsibleParty === "");
    if (hasRelationToRP.length > 0) {
        result.personInfoScreening = false;
        result.government = false;
        result.exchange = false;
        result.supplemental = false;
        result.dispatch = false;
    }

    if (value?.longTermCare) {
        result.longTermCare = true;
    }

    return result;
}

function resetInterview() {
    return initialState;
}

function setSectionComplete(state, action) {
    const section = action.value;
    return markVisited(section, state);
}

export const wizardStatusReducer = createReducerFromMap(initialState, {
    GET_INTERVIEW_COMPLETE: getInterview,
    UPDATE_ENTRY_COMPLETE: markVisited.bind(this, "entry"),
    UPDATE_COVERAGE_COMPLETE: markVisited.bind(this, "coverage"),
    UPDATE_PATIENT_INFO_SCREENING_COMPLETE: markVisited.bind(this, "patientInfoScreening"),
    ADD_HOUSEHOLD_MEMBER_COMPLETE: markHouseholdMatrixAsVisited,
    UPDATE_HOUSEHOLD_MEMBER_COMPLETE: markHouseholdMatrixAsVisited,
    UPDATE_HOUSEHOLD_MEMBERS_COMPLETE: markHouseholdMatrixAsVisited,
    UPDATE_PERSONS_INFO_SCREENING_COMPLETE: markPersonInfoScreengAsVisited,
    SET_PI_GATE_COMPLETE: markVisited.bind(this, "pi"),
    SET_SECTION_COMPLETE: setSectionComplete,
    RESET_INTERVIEW: resetInterview,
});
